
import server from '../../public/server/server'
const assitanceApi = {
    //----------------------社会求助-----------------------------------
    save:server.requestPath +  '/help/save', // 求助添加/编辑
    queryListByPage:server.requestPath +  '/help/queryListByPage', // 求助列表
    setIgnore:server.requestPath +  '/help/setIgnore', // 是否禁用启用
    findById:server.requestPath +  '/help/findById', // 查看求助详情
    saveClue:server.requestPath +  '/help/saveClue', // 添加线索
    sendAlarm:server.requestPath +  '/help/sendAlarm', // 发起报警
    delClue:server.requestPath +  '/help/delClue', // 删除线索
    setResolved:server.requestPath +  '/help/setResolved', // 删除线索
    //----------------------失物招领-----------------------------------
	lostQueryListByPage:server.requestPath+'/lost/queryListByPage',//失物招领列表
	lostSave:server.requestPath+'/lost/save',//发布
	setAudit:server.requestPath+'/lost/setAudit',//0.审核中 1.通过 2.拒绝
	setEnable:server.requestPath+'/lost/setEnable',//启用禁用
	setFinished:server.requestPath+'/lost/setFinished',//完成
}


export {
	assitanceApi
}
